import store from '@/store/store';
import Connexion from '@/views/connexion/Connexion.vue';
import IndexHome from '@/views/home/index.vue';
import TableauDeBord from '@/views/home/TableauDeBord.vue';
import ListeRecommendation from '@/views/home/ListeRecommendation.vue';
import IndexRecommandation from '@/views/recommandations/index.vue';
import PointDeVente from '@/views/recommandations/pointDeVente.vue';
import CreerPointDeVente from '@/views/recommandations/creerPointDeVente.vue';
import ListePanneau from '@/views/recommandations/listePanneau.vue';
import CreerPanneau from '@/views/recommandations/creerPanneau.vue';
import DetailRecommandation from '@/views/recommandations/detailRecommandation.vue';
import Panier from '@/views/panier/panier.vue';
import LoginRequired from '@/loginRequired';
import ListeClient from '@/views/client/listeClients.vue';
import DetailClient from '@/views/client/detailClient.vue';
import RechercheConcurrent from '@/views/Concurrent/rechercheConcurrent.vue';
import ParametrerConcurrent from '@/views/Concurrent/parametrerConcurrent.vue';

import { PAGE_DEFAULT } from './routerConf';

export default [
  {
    path: '*',
    redirect: PAGE_DEFAULT,
  },
  {
    path: '/connexion',
    name: 'connexion',
    component: Connexion,
  },
  {
    path: '/',
    name: 'indexHome',
    component: IndexHome,
    redirect: PAGE_DEFAULT,
    children: [
      {
        path: '/tableau-de-bord',
        name: 'tableau-de-bord',
        component: TableauDeBord,
      },
      {
        path: '/liste-recommendation',
        name: 'liste-recommendation',
        component: ListeRecommendation,
      },
      {
        path: '/recommandation',
        component: IndexRecommandation,
        children: [
          {
            path: '/',
            name: 'point-de-vente',
            component: PointDeVente,
          },
          {
            path: '/recommandation/creer-point-de-vente',
            name: 'creer-point-de-vente',
            component: CreerPointDeVente,
          },
          {
            path: '/recommandation/liste-panneau',
            name: 'liste-panneau',
            component: ListePanneau,
          },
          {
            path: '/recommandation/creer-panneau',
            name: 'creer-panneau',
            component: CreerPanneau,
          },
          {
            path: '/recommandation/modifier-point-de-vente',
            name: 'modifier-point-de-vente',
            component: CreerPointDeVente,
          },
          {
            path: '/recommandation/modifier-panneau/:guid',
            name: 'modifier-panneau',
            component: CreerPanneau,
          },
          {
            path: '/recommandation/view-panneau/:guid',
            name: 'view-panneau',
            component: CreerPanneau,
          }
        ],
      },
      {
        path: '/panier',
        name: 'panier',
        component: Panier,
      },
      {
        path: '/detail-recommandation/:id',
        name: 'detail-recommandation',
        component: DetailRecommandation,
      },
      {
        path: '/liste-client',
        name: 'liste-client',
        component: ListeClient,
      },
      {
        path: '/detail-client/:type/:id',
        name: 'detail-client',
        component: DetailClient,
      },
      {
        path: '/recherche-concurrent',
        name: 'recherche-concurrent',
        component: RechercheConcurrent,
      },
      {
        path: '/parametrer-concurrent',
        name: 'parametrer-concurrent',
        component: ParametrerConcurrent,
      }
    ],
    beforeEnter: (to, from, next) => {
      if (LoginRequired(store)) {
        next();
      } else {
        next('/connexion');
      }
    },
  },
];
